import { Component, OnInit } from '@angular/core';
import { ThemePalette, ProgressSpinnerMode } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';
import { GlobalService } from '../global.service';
import { HttpService } from '../http.service';

@Component({
  selector: 'app-counter-sale-for-byproducts',
  templateUrl: './counter-sale-for-byproducts.component.html',
  styleUrls: ['./counter-sale-for-byproducts.component.scss']
})
export class CounterSaleForByproductsComponent implements OnInit {

  counter_list: any = [];
  busness_type_id_list = [];
  selected_counter_id: any;
  selected_date: any = new Date().toISOString().split('T')[0];
  selected_business_type_ids: any;
  is_data_available = true;
  is_document_available: boolean = true;
  document_file: any = null;
  pdf_data: any = null;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  booth_code_list: string[];
  title: string;

  constructor(private http: HttpService, private domSanitizer: DomSanitizer, private global: GlobalService) {
    this.title = this.global._active_display_name;

    this.http.serveByProductCounters().subscribe((data) => {
      console.log(data);
      this.counter_list = data;
    }, (error) => {
      console.error(error);
    });

    this.http.serveBusinessTypeForByProductPrice().subscribe((data:any) => {
      console.log(data);
      this.busness_type_id_list = data;
    }, (error) => {
      console.error(error);
    })
  }

  getClicked() {
    let data_dict = {
      'order_date': this.selected_date,
      'counter_id': this.selected_counter_id,
    };
    console.log(data_dict);
    this.is_document_available = false;
    this.http.serveCounterSaleByProductsReport(data_dict).subscribe((data) => {
      console.log(data);
      if (data['alert_status'] == true) {
        alert(data['alert']);
        this.is_document_available = true;
      }
      else{
        this.document_file = data;
        this.pdf_data = this.domSanitizer.bypassSecurityTrustResourceUrl('data:application/pdf;base64,' + data['pdf']);
        this.is_document_available = true;
      }
    }, (error) => {
      this.is_document_available = true;
    });
  }

  getPdf() {
    return this.domSanitizer.bypassSecurityTrustResourceUrl(this.pdf_data);
  }

  downloadClicked() {
    const linkSource = 'data:application/pdf;base64,' + this.document_file['pdf'];
    const downloadLink = document.createElement("a");
    const fileName = this.document_file['file_name'];
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  changeEvent() {
    this.document_file = null;
  }

  ngOnInit() {
  }

}
